import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Link,
  Svg,
  Path,
  Font,
} from "@react-pdf/renderer";
import ReactHtmlParser from "react-html-parser";
import { sortCandidatesByLastName } from "../../lib/candidates";

const titleFontSrc =
  "https://use.typekit.net/af/85d488/00000000000000003b9ae7a3/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3";
const titleFontBoldSrc =
  "https://use.typekit.net/af/cf0e56/00000000000000003b9ae7a5/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n8&v=3";
const titleFontThinSrc =
  "https://use.typekit.net/af/8503f0/00000000000000003b9ae7a4/27/d?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3";
const textFontSrc =
  "https://use.typekit.net/af/918d82/00000000000000007735ad58/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3";
const textFontBoldSrc =
  "https://use.typekit.net/af/c99e0e/00000000000000007735ad79/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3";
const textFontCondensedSrc =
  "https://use.typekit.net/af/8637d4/00000000000000007735ad64/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n4&v=3";
const textFontCondensedBoldSrc =
  "https://use.typekit.net/af/248e32/00000000000000007735ad76/30/a?primer=7cdcb44be4a7db8877ffa5c0007b8dd865b3bbc383831fe2ea177f62257a9191&fvd=n7&v=3";

const starSVG = (
  <Path
    d="M23.9794 9.59324C23.8968 9.32313 23.7109 9.0738 23.4838 8.90758C23.2567 8.74136 22.9676 8.63747 22.6786 8.63747H15.7204C15.6172 8.63747 15.5139 8.57514 15.4726 8.47125L13.346 1.82246C13.2221 1.44847 12.9537 1.13681 12.6027 0.991364C12.2517 0.825144 11.8387 0.825144 11.4877 0.991364C11.1367 1.15758 10.8476 1.44847 10.7444 1.82246L8.61773 8.47125C8.59708 8.57514 8.49384 8.65825 8.36996 8.63747H1.39116C0.998856 8.63747 0.627204 8.78291 0.358788 9.0738C0.090373 9.36468 -0.0335111 9.75945 0.00778356 10.1542C0.0490783 10.549 0.255552 10.9022 0.565262 11.1308L6.20199 15.2239C6.20199 15.2239 6.32587 15.4109 6.28458 15.5148L4.11661 22.1636C3.99272 22.5376 4.03402 22.9531 4.24049 23.2856C4.42632 23.618 4.75667 23.8674 5.14897 23.9505C5.54127 24.0336 5.93357 23.9505 6.24328 23.7219L11.8594 19.608C11.8594 19.608 12.0658 19.5456 12.1484 19.608L17.7645 23.7219C18.0742 23.9505 18.4872 24.0336 18.8588 23.9505C19.2511 23.8674 19.5815 23.618 19.7673 23.2856C19.9531 22.9531 20.0151 22.5376 19.8912 22.1636L17.7232 15.5148C17.6819 15.4109 17.7232 15.2863 17.8058 15.2239L23.4425 11.1308C23.6696 10.9645 23.8555 10.7152 23.9381 10.4451C24.0206 10.175 24.0206 9.86334 23.9381 9.59324H23.9794ZM22.8231 10.2166L17.1864 14.3097C16.9593 14.4759 16.7734 14.7253 16.6908 14.9954C16.6082 15.2655 16.6082 15.5771 16.6908 15.8473L18.8588 22.496C18.9001 22.5999 18.8588 22.7246 18.7762 22.7869C18.6936 22.8493 18.5697 22.8493 18.4872 22.7869L12.8711 18.673C12.644 18.5068 12.3549 18.4029 12.0658 18.4029C11.7768 18.4029 11.4877 18.5068 11.2606 18.673L5.64451 22.7869C5.64451 22.7869 5.43804 22.8493 5.35545 22.7869C5.27286 22.7246 5.23156 22.5999 5.27286 22.496L7.44083 15.8473C7.52342 15.5771 7.52342 15.2655 7.44083 14.9954C7.35824 14.7253 7.17241 14.4759 6.94529 14.3097L1.24662 10.2373C1.24662 10.2373 1.12274 10.0503 1.16403 9.94645C1.20533 9.84256 1.28792 9.78023 1.4118 9.78023H8.36996C8.65902 9.78023 8.94808 9.69712 9.17521 9.5309C9.40233 9.36468 9.58815 9.11535 9.67074 8.84525L11.7768 2.17568C11.8181 2.07179 11.9007 2.00946 12.0245 2.00946C12.1484 2.00946 12.231 2.07179 12.2723 2.17568L14.399 8.82447C14.4816 9.09458 14.6674 9.34391 14.8945 9.51013C15.1216 9.67634 15.4107 9.78023 15.6998 9.78023H22.6579C22.7612 9.78023 22.8644 9.84256 22.9057 9.94645C22.947 10.0503 22.9057 10.175 22.8231 10.2373V10.2166Z"
    fill="#17BEBB"
  />
);
Font.register({
  family: "garage-gothic",
  format: "opentype",
  fonts: [
    { src: titleFontSrc, fontWeight: 400, fontStyle: "normal" },
    { src: titleFontThinSrc, fontWeight: 700, fontStyle: "normal" },
    { src: titleFontBoldSrc, fontWeight: 800, fontStyle: "normal" },
  ],
});
Font.register({
  family: "haboro-soft",
  format: "opentype",
  fonts: [
    { src: textFontSrc, fontWeight: "normal", fontStyle: "normal" },
    { src: textFontBoldSrc, fontWeight: "bold", fontStyle: "normal" },
  ],
});
Font.register({
  family: "haboro-soft-condensed",
  format: "opentype",
  fonts: [
    { src: textFontCondensedSrc, fontWeight: "normal", fontStyle: "normal" },
    { src: textFontCondensedBoldSrc, fontWeight: "bold", fontStyle: "normal" },
  ],
});
Font.register({
  family: "Nanum Gothic",
  src: "https://cdn.jsdelivr.net/gh/google/fonts@main/ofl/nanumgothic/NanumGothic-ExtraBold.ttf",
});

let styles = StyleSheet.create({
  page: {
    flexDirection: "col",
    backgroundColor: "#fff",
    fontFamily: "haboro-soft",
    padding: "40px 60px",
  },
  section: {
    justifyContent: "flex-start",
    padding: "6px 0",
    fontSize: "10pt",
  },
  sectionHightlight: {
    margin: "0 35px",
    justifyContent: "flex-start",
    backgroundColor: "#efefef",
    padding: "6px",
    fontSize: "11pt",
  },
  ballotContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
  },
  sectionTop: {
    display: "flex",
    flexDirection: "column",
  },
  sectionBottom: {
    position: "absolute",
    bottom: "2px",
    width: "100%",
    marginLeft: "15%",
  },
  guideTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  starImg: {
    margin: "5px",
  },
  title: {
    fontSize: "43pt",
    textAlign: "center",
    color: "#193946",
    fontFamily: "garage-gothic",
    fontWeight: "400",
    textTransform: "uppercase",
  },
  titleBold: {
    fontSize: "44pt",
    textAlign: "center",
    marginBottom: "10px",
    color: "#193946",
    fontFamily: "garage-gothic",
    fontWeight: "700",
    textTransform: "uppercase",
  },
  bottomLink: {
    position: "fixed",
    bottom: "30px",
    textAlign: "center",
    fontFamily: "garage-gothic",
    fontSize: "16pt",
    fontWeight: "bold",
    color: "#193946",
    textTransform: "uppercase",
  },
  link: {
    color: "#193946",
    textDecoration: "none",
  },
  raceText: {
    textAlign: "center",
    textSize: "8px",
    color: "#193946",
    fontFamily: "garage-gothic",
    fontWeight: "bold",
  },
  voteText: {
    fontWeight: "bold",
  },
  candidateName: {
    fontFamily: "haboro-soft",
    display: "inline-block",
    color: "#193946",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  contentCandidate: {
    fontFamily: "haboro-soft",
    fontWeight: "400",
    color: "#193946",
  },
  raceContainer: {
    padding: "5px 0 15px 0",
  },
  raceHeader: {
    backgroundColor: "#1b0e44",
    color: "white",
  },
  raceHeaderText: {
    textAlign: "left",
    fontFamily: "garage-gothic",
    fontSize: "20pt",
    fontWeight: "700",
    color: "#EC704C",
    borderBottom: "3px solid #EC704C",
    width: 480,
  },
  linkEndorsements: {
    fontFamily: "haboro-soft",
    color: "#1b0e44",
  },
  endorsementText: {
    fontFamily: "haboro-soft",
    fontWeight: "normal",
    color: "#193946",
  },
  yourChoice: {
    backgroundColor: "#abe188",
    textTransform: "uppercase",
  },
});

const stylesKR = StyleSheet.create({
  page: {
    flexDirection: "col",
    backgroundColor: "#fff",
    fontFamily: "Nanum Gothic",
    padding: "40px 60px",
  },
  section: {
    justifyContent: "flex-start",
    padding: "6px 0",
    fontSize: "10pt",
  },
  sectionHightlight: {
    margin: "0 35px",
    justifyContent: "flex-start",
    backgroundColor: "#efefef",
    padding: "6px",
    fontSize: "11pt",
  },
  ballotContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    flexWrap: "wrap",
  },
  sectionTop: {
    display: "flex",
    flexDirection: "column",
  },
  sectionBottom: {
    position: "absolute",
    bottom: "2px",
    width: "100%",
    marginLeft: "15%",
  },
  guideTitle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  starImg: {
    margin: "5px",
  },
  title: {
    fontSize: "33pt",
    textAlign: "center",
    color: "#193946",
    fontFamily: "Nanum Gothic",
    fontWeight: "400",
    textTransform: "uppercase",
  },
  titleBold: {
    fontSize: "34pt",
    textAlign: "center",
    marginBottom: "10px",
    color: "#193946",
    fontFamily: "Nanum Gothic",
    fontWeight: "700",
    textTransform: "uppercase",
  },
  bottomLink: {
    position: "fixed",
    bottom: "30px",
    textAlign: "center",
    fontFamily: "Nanum Gothic",
    fontSize: "12pt",
    fontWeight: "bold",
    color: "#193946",
    textTransform: "uppercase",
  },
  link: {
    color: "#193946",
    textDecoration: "none",
  },
  raceText: {
    textAlign: "center",
    textSize: "8px",
    color: "#193946",
    fontFamily: "Nanum Gothic",
    fontWeight: "bold",
  },
  voteText: {
    fontWeight: "bold",
  },
  candidateName: {
    fontFamily: "haboro-soft",
    display: "inline-block",
    color: "#193946",
    textTransform: "uppercase",
    fontWeight: "bold",
  },
  contentCandidate: {
    fontFamily: "Nanum Gothic",
    fontWeight: "400",
    color: "#193946",
  },
  raceContainer: {
    padding: "5px 0 15px 0",
  },
  raceHeader: {
    backgroundColor: "#1b0e44",
    color: "white",
  },
  raceHeaderText: {
    textAlign: "left",
    fontFamily: "Nanum Gothic",
    fontSize: "20pt",
    fontWeight: "700",
    color: "#EC704C",
    borderBottom: "3px solid #EC704C",
    width: 480,
  },
  linkEndorsements: {
    fontFamily: "haboro-soft",
    color: "#1b0e44",
  },
  endorsementText: {
    fontFamily: "Nanum Gothic",
    fontWeight: "normal",
    color: "#193946",
  },
  yourChoice: {
    backgroundColor: "#abe188",
    textTransform: "uppercase",
  },
});


// Create Document Component
const MyPDF2 = (props) => {
  let viewDisplay = [];
  let amendmentsDisplay = [];

  // let amendmentsDisplay = [];
  let races = props.ballots;
  let amendments = props.amendments;
  let copy = props.copy;
  let language = props.lang;
  if (language === "kr") {
    styles = stylesKR;
  }
  // let amendments = props.amendments && props.amendments.items;
  // const orderPDF = [
  //   "governor",
  //   "senate",
  //   "lieutenant_governor",
  //   "secretary_of_state",
  //   "attorney_general",
  //   "labor_commissioner",
  //   "agriculture_commissioner",
  //   "insurance_fire_commissioner",
  //   "state_school_superintendent",
  //   "us_congress",
  //   "state_senate",
  //   "state_house",
  // ];
  // function sortRace(ballot, orderArray) {
  //   return ballot.sort(function (a, b) {
  //     let indexA = orderArray.indexOf(a.race_type);
  //     let indexB = orderArray.indexOf(b.race_type);
  //     return indexA >= indexB ? 1 : -1;
  //   });
  // }
  // let orderedRace = sortRace(races, orderPDF);
  let orderedRace = races;
  let selections = props.selections && JSON.parse(props.selections);
  let selectedRaces = selections && selections.map((i) => i.race);
  // let orderedRace = races;
  let options = {
    decodeEntities: true,
    transform: function transform(node, index) {
      let element = null;
      if (node.type === "text") {
        element = node.data ? (
          <Text key={index} style={styles.endorsementText}>
            {node.data}
          </Text>
        ) : null;
      }
      if (node.type === "tag" && node.name === "a") {
        element = (
          <Text key={index} style={styles.endorsementText}>
            <Link src={node.attribs.href} style={styles.linkEndorsements}>
              {node.children[0] && node.children[0].data}
            </Link>
          </Text>
        );
      }
      if (node.type === "tag" && node.name === "li") {
        let nodeTemp = node.children[0] && node.children[0];
        if (nodeTemp.type === "text") {
          element = nodeTemp.data ? (
            <Text key={index} style={styles.endorsementText}>
              {nodeTemp.data}
            </Text>
          ) : null;
        }
        if (nodeTemp.type === "tag" && nodeTemp.name === "a") {
          element = (
            <Text key={index} style={styles.endorsementText}>
              <Link src={nodeTemp.attribs.href} style={styles.linkEndorsements}>
                {nodeTemp.children[0] && nodeTemp.children[0].data}
              </Link>
            </Text>
          );
        }
      }
      return element;
    },
  };
  orderedRace.map((race, i) => {
    // let candidates = race.candidates;
    // candidates.sort((a, b) =>
    //   a.party.localeCompare(b.party, "en", { sensitivity: "base" })
    // );
    let candidates = sortCandidatesByLastName(race.candidates);
    let isMinimal = candidates.every((item) => !item.endorsements);
    //View for selected candidates
    if (selections && selectedRaces.includes(race.race_name)) {
      let selected = selections.find((i) => i.race === race.race_name);
      let candidate = candidates.find((i) => {
        return i.name === selected.selection;
      });
      if (
        candidate.name === "Claudia De la Cruz" ||
        candidate.name === "Cornel West"
      ) {
        viewDisplay.push(
          <View key={i} style={styles.raceContainer}>
            <Text style={styles.raceHeaderText}>
              {race.race_name_display && race.race_name_display.toUpperCase()}
            </Text>
            <View style={styles.section} key={i}>
              <Text>
                <Text style={styles.candidateName}>
                  {candidate.name +
                    " (" +
                    candidate.party.charAt(0).toUpperCase() +
                    ") "}
                </Text>
                <Text>
                  -{" "}
                  <Text style={styles.yourChoice}>
                    {copy.third_party_ballot}
                  </Text>
                </Text>
              </Text>
            </View>
          </View>
        );
      } else {
        viewDisplay.push(
          <View key={i} style={styles.raceContainer}>
            <Text style={styles.raceHeaderText}>
              {race.race_name_display && race.race_name_display.toUpperCase()}
            </Text>
            <View style={styles.section} key={i}>
              <Text>
                <Text style={styles.candidateName}>
                  {candidate.name +
                    " (" +
                    candidate.party.charAt(0).toUpperCase() +
                    ") "}
                </Text>
                <Text>
                  - <Text style={styles.yourChoice}>{copy.your_choice}</Text>
                </Text>
              </Text>
            </View>
          </View>
        );
      }
    } else if (isMinimal) {
      viewDisplay.push(
        <View key={i} style={styles.raceContainer}>
          <Text style={styles.raceHeaderText}>
            {race.race_name_display && race.race_name_display.toUpperCase()}
          </Text>
          {candidates &&
            candidates.map((candidate, i) => {
              return (
                <View style={styles.section} key={i}>
                  <Text>
                    <Text style={styles.candidateName}>
                      {" "}
                      {candidate.name +
                        " (" +
                        candidate.party.charAt(0).toUpperCase() +
                        ") "}
                    </Text>
                  </Text>
                </View>
              );
            })}
        </View>
      );
    } else {
      //View for normal race
      viewDisplay.push(
        <View key={i} style={styles.raceContainer}>
          <Text style={styles.raceHeaderText}>
            {race.race_name_display && race.race_name_display.toUpperCase()}
          </Text>
          {candidates &&
            candidates.map((candidate, i) => {
              let endorsements =
                candidate.endorsements &&
                candidate.endorsements[0].children[0].text
                  .replaceAll(/• /g, "")
                  .replaceAll(/<p[^>]*>/g, "")
                  .replaceAll(`</p>`, "")
                  .replaceAll(/<ul[^>]*>/g, "")
                  .replaceAll(`</ul>`, "")
                  .replaceAll(/\s*<sup.*?\/sup>\s*/g, "");
              let displayEndorsements;
              if (
                endorsements &&
                (endorsements.includes("To learn more") ||
                  endorsements ===
                    "<a href='https://psc.gcvoters.org/' target='_blank'>Learn more</a> about the Public Service Commission")
              ) {
                displayEndorsements = (
                  <Text>{ReactHtmlParser(endorsements, options)}.</Text>
                );
              } else if (endorsements) {
                endorsements.replace(
                  `<p><a href='https://psc.gcvoters.org/' target='_blank'>Learn more</a> about the Public Service Commission</p>`,
                  ""
                );
                let endorsementParsed = endorsements.split(", ").slice(0, 3);
                let endorsementSeparations =
                  endorsementParsed.length === 1
                    ? endorsementParsed
                    : endorsementParsed.map((endorsement, key) => {
                        return key === endorsementParsed.length - 1 ? (
                          <Text key={key}>
                            {copy.and}{endorsement}
                          </Text>
                        ) : (
                          <Text key={key}>{endorsement}, </Text>
                        );
                      });

                displayEndorsements = (
                  <Text style={styles.contentCandidate}>
                    {copy.is_endorsed_by} {endorsementSeparations}{copy.is_endorsed_by_kr}.
                  </Text>
                );
              }
              return (
                <View style={styles.section} key={i}>
                  <Text>
                    <Text style={styles.candidateName}>
                      {" "}
                      {candidate.name +
                        " (" +
                        candidate.party.charAt(0).toUpperCase() +
                        ") "}
                    </Text>
                    <Text style={styles.contentCandidate}>
                      {endorsements
                        ? displayEndorsements
                        : copy.no_endorsements}
                    </Text>
                  </Text>
                </View>
              );
            })}
        </View>
      );
    }
    return viewDisplay;
  });
  // orderedRace.map((race, i) => {
  //   let candidates = race.candidates;
  //   let isMinimal = candidates.every(
  //     (item) =>
  //       item.bio.length == 0 &&
  //       item.endorsements.length == 0 &&
  //       item.issues.length == 0
  //   );
  //   //View for isMinimal candidates
  //   if (isMinimal) {
  //     let selected = selections
  //       ? selections.find((i) => i.race === race.race_name)
  //       : null;
  //     let candidateSelected = {};
  //     if (selected) {
  //       candidateSelected = candidates.find((i) => {
  //         return i.name === selected.selection;
  //       });
  //     }

  //     viewDisplay.push(
  //       <View key={i} style={styles.raceContainer}>
  //         <Text style={styles.raceHeaderText}>
  //           {race.race_name_display && race.race_name_display.toUpperCase()}
  //         </Text>
  //         {candidates &&
  //           candidates.map((candidate, i) => {
  //             return (
  //               <View style={styles.section} key={i}>
  //                 <Text>
  //                   <Text style={styles.candidateName}>{candidate.name}</Text>
  //                   {candidateSelected.name === candidate.name ? (
  //                     <Text>
  //                       - <Text style={styles.yourChoice}>Your Choice</Text>
  //                     </Text>
  //                   ) : (
  //                     ""
  //                   )}
  //                 </Text>
  //               </View>
  //             );
  //           })}
  //       </View>
  //     );
  //   } else {
  //     //View for normal race
  //     viewDisplay.push(
  //       <View key={i} style={styles.raceContainer}>
  //         <Text style={styles.raceHeaderText}>
  //           {race.race_name && race.race_name.toUpperCase()}
  //         </Text>
  //         {candidates &&
  //           candidates.map((candidate, i) => {
  //             let endorsements =
  //               candidate.endorsements &&
  //               candidate.endorsements
  //                 .replaceAll(/• /g, "")
  //                 .replaceAll(/<p[^>]*>/g, "")
  //                 .replaceAll(`</p>`, "")
  //                 .replaceAll(/<ul[^>]*>/g, "")
  //                 .replaceAll(`</ul>`, "");
  //             let displayEndorsements;
  //             if (
  //               endorsements &&
  //               (endorsements.includes("To learn more") ||
  //                 endorsements ===
  //                   "<a href='https://psc.gcvoters.org/' target='_blank'>Learn more</a> about the Public Service Commission")
  //             ) {
  //               displayEndorsements = (
  //                 <Text>{ReactHtmlParser(endorsements, options)}.</Text>
  //               );
  //             } else {
  //               endorsements.replace(
  //                 `<p><a href='https://psc.gcvoters.org/' target='_blank'>Learn more</a> about the Public Service Commission</p>`,
  //                 ""
  //               );
  //               let endorsementParsed = endorsements.split(", ").slice(0, 3);
  //               let endorsementSeparations =
  //                 endorsementParsed.length === 1
  //                   ? endorsementParsed
  //                   : endorsementParsed.map((endorsement, key) => {
  //                       return key === endorsementParsed.length - 1 ? (
  //                         <Text key={key}>and {endorsement}</Text>
  //                       ) : (
  //                         <Text key={key}>{endorsement}, </Text>
  //                       );
  //                     });
  //               displayEndorsements = (
  //                 <Text>is endorsed by {endorsementSeparations}.</Text>
  //               );
  //             }
  //             return (
  //               <View style={styles.section} key={i}>
  //                 <Text>
  //                   <Text style={styles.candidateName}>{candidate.name}</Text>
  //                   <Text style={styles.contentCandidate}>
  //                     {endorsements
  //                       ? displayEndorsements
  //                       : "We do not have endorsements listed for this candidate at this time."}
  //                   </Text>
  //                 </Text>
  //               </View>
  //             );
  //           })}
  //       </View>
  //     );
  //   }
  //   return viewDisplay;
  // });
  amendments &&
    amendments.map((amendment, i) => {
      //View for selected candidates
      let isSelected =
        selections && selections.find((i) => i.race === amendment.amendment_id);
      amendmentsDisplay.push(
        <View key={i} style={styles.raceContainer}>
          <Text style={styles.raceHeaderText}>
            {amendment.amendment_id && amendment.amendment_id.toUpperCase()}
          </Text>
          <View key={i} style={styles.section}>
            <Text>
              <Text style={styles.candidateName}>
                {amendment.amendment_title}
              </Text>
              {isSelected ? (
                <Text>
                  -{" "}
                  <Text style={styles.yourChoice}>
                    Voting {" "}{isSelected.selection}
                  </Text>
                </Text>
              ) : null}
            </Text>
          </View>
        </View>,
      );
      return amendmentsDisplay;
    });
  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        <View style={styles.sectionTop}>
          <View style={styles.guideTitle}>
            <Svg
              style={styles.starImg}
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
            >
              {starSVG}
            </Svg>
            <Text style={ language==="kr" ? stylesKR.title : styles.title}>{copy.your_personalized}</Text>
            <Svg
              style={styles.starImg}
              viewBox="0 0 24 24"
              width="16"
              height="16"
              fill="none"
            >
              {starSVG}
            </Svg>
          </View>
          <Text style={styles.titleBold}>{copy.voter_guide}</Text>
          <View style={styles.ballotContainer}>{viewDisplay}</View>
          <View style={styles.ballotContainer}>{amendmentsDisplay}</View>
        </View>
        <View style={styles.sectionBottom} fixed>
          <Text style={styles.bottomLink}>
            <Link style={styles.link} src="http://thegeorgiavoterguide.com/">
              thegeorgiavoterguide.com
            </Link>{" "}
            | {copy.paid_for}
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default MyPDF2;
